import { mapGetters } from 'shared/stores/core/helpers';

/**
 * Provides access to a shared toolbox instance (created in the UiLoader) allowing
 * @type {{props: {toolbox: {type: ObjectConstructor, required: boolean}}, computed: {hasAnnotations(): *}, methods: {runTool(*=, *=): *, toolIsEnabled(*=): *}}}
 */
export const toolbarMixin = {
  props: {
    // The "toolbox" should be an instance of the toolbox imported from ./tools/core
    toolbox: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters('USCOPE', 'VIEWPORT', 'ANNOTATIONS', 'ANNOTATIONS/selectedRegion'),
    hasAnnotations () {
      return !!this.selectedRegion;
    }
  },

  methods: {
    runTool (toolName, event) {
      return this.toolbox.run.call(this, toolName, event);
    },

    toolIsEnabled (toolName) {
      return this.toolbox.checkDelegates.call(this, toolName);
    }
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-ui/toolbar-mixin.js